import Steps from "common/Steps/Steps";
import styled from "styled-components";
import { OnboardingStep } from "@shared/features/onboarding/types";
import Flex from "common/Boxes/Flex";
import useMedia from "utils/hooks/useMedia";
import { MOBILE_SEARCH } from "common/constants";
import { STEP_TO_TITLE } from "@shared/features/onboarding/constants";

interface OnboardingStepsProps {
  currentStep?: OnboardingStep;
}

const OnboardingSteps = ({ currentStep }: OnboardingStepsProps) => {
  const isMobile = useMedia([`(max-width: ${MOBILE_SEARCH})`], [true], false);

  return (
    <Flex $justifyContent="center" style={{ maxWidth: 500 }}>
      <StyledOnboardingSteps
        size="small"
        labelPlacement="vertical"
        percent={isMobile ? undefined : 100}
        current={currentStep}
        responsive={false}
        $isMobile={isMobile}
      >
        {Object.values(STEP_TO_TITLE).map((stepTitle, index) => (
          <Steps.Step
            title={isMobile ? undefined : stepTitle}
            key={index}
            className={
              currentStep && index === currentStep - 1 ? "previous-step" : ""
            }
          />
        ))}
      </StyledOnboardingSteps>
    </Flex>
  );
};

export default OnboardingSteps;

export const StyledOnboardingSteps = styled(Steps)<{ $isMobile: boolean }>`
  &.ant-steps.ant-steps-small .ant-steps-item-title {
    font-size: ${(p) => p.theme.typography.fontSizes.S};
  }
  &.ant-steps-with-progress .ant-steps-item .ant-steps-item-tail {
    top: ${(p) => (p.$isMobile ? 4 : 12)}px !important;
  }
  .ant-steps-item-wait .ant-steps-item-container .ant-steps-item-tail:after,
  .ant-steps-item-process .ant-steps-item-container .ant-steps-item-tail:after {
    background: ${(p) => p.theme.colors.disabledText};
  }
  .anticon svg {
    margin-top: 6px;
  }
  &.ant-steps.ant-steps-label-vertical .ant-steps-item-content {
    margin-top: 8px;
  }

  ${(p) =>
    p.$isMobile &&
    `
  .ant-steps-icon {
    display: none;
  }
  &.ant-steps-small .ant-steps-item-icon {
    width: 12px;
    height: 12px;
  }
  &.ant-steps-small .ant-steps-item-tail {
    top: 2px;
  }
  &.ant-steps-label-vertical .ant-steps-item-tail {
    padding: 4px 0px;
    margin-left: 11px;
  }
   .ant-steps-item:not(:last-child) {
    width: 30px;
  }
   .ant-steps-item:last-child {
    width: 12px;
  }
    &.ant-steps-label-vertical.ant-steps-small:not(.ant-steps-dot) .ant-steps-item-icon {
    margin-left: 0;
  }
  &.ant-steps-label-vertical .ant-steps-item-content {
  display: none;
  width: 0;
  }
   .ant-steps-item-process .ant-steps-item-container .ant-steps-item-icon:after {
    border: 1px solid ${p.theme.colors.primaryBlue};
    content: "";
    display: inline-block;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    transform: translate(-4px, -4px);
  }
  .ant-steps-item-finish .ant-steps-item-icon {
    background: ${p.theme.colors.primaryBlue};
  }
   .ant-steps-item-process .ant-steps-item-container .ant-steps-item-tail {
    width: 16px;
    margin-left: 14px;
  }
  .ant-steps-item-finish .ant-steps-item-container .ant-steps-item-tail {
    width: 20px;
  }
    .previous-step .ant-steps-item-container .ant-steps-item-tail {
    width: 16px;
  }
  `}
`;
